import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export {
    StyledCounter,
    StyledPositionRelative,
    StyledTextarea,
    StyledTextareaContainer,
} from "app/pages/sales-intelligence/common-components/modals/BulkAddModal/styles";

export const StyledBulkInputText = styled.p`
    ${setFontVariant("body1", colorsPalettes.carbon[400])}
    margin: 0;
`;

export const StyledBulkCapError = styled.p`
    ${setFontVariant("body2", colorsPalettes.red[400])}
    margin: 0;
`;
